var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBulletLock = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 .5)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "#02769D",
    strokeWidth: 2,
    fill: "#E7F3F9",
    cx: 25,
    cy: 25,
    r: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 10h30v30H10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.115 21.208h-.768v-3.07A6.145 6.145 0 0 0 25.208 12a6.145 6.145 0 0 0-6.139 6.139v3.07h-.767A2.305 2.305 0 0 0 16 23.51v10.743a2.305 2.305 0 0 0 2.302 2.302h13.813a2.305 2.305 0 0 0 2.302-2.302V23.51a2.305 2.305 0 0 0-2.302-2.303zm-11-3.07a4.097 4.097 0 0 1 4.093-4.092 4.097 4.097 0 0 1 4.093 4.093v3.07h-8.185v-3.07z",
    fill: "#02769D",
    fillRule: "nonzero"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBulletLock);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/bullet-lock.276ed5f9bbb747b8f4e7d33fb92187a8.svg";